import { render, staticRenderFns } from "./LabeledPane.vue?vue&type=template&id=7063b5a1&"
import script from "./LabeledPane.vue?vue&type=script&lang=ts&"
export * from "./LabeledPane.vue?vue&type=script&lang=ts&"
import style0 from "./LabeledPane.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports